import script from "./EventRoomOne.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventRoomOne.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__